import React, {Component} from 'react';
import '../css/style.css';
import ReactToPrint from 'react-to-print';
import couterpart from 'counterpart';
import { withRouter } from 'react-router-dom';

import MenuComponent2 from './MenuComponent2';
import OrderPrintContent from './OrderPrintContent';

import WorkOrderDataService from '../services/WorkOrderDataService';

import { FaPrint} from 'react-icons/fa';
import {TiArrowBackOutline} from 'react-icons/ti';
import { ICON_COLOR } from '../icon';

class OrderPrintResult extends Component {
    constructor () {
        super();
        this.state = {
            workOrders: []
        };
    }

    componentDidMount () {
        var ids = sessionStorage.getItem("orderIds");
        ids = ids.split(",");
        WorkOrderDataService.retrieveWorkOrdersByOrderIds(ids).then(data => {
            if (data.message === undefined){ 
                this.setState({workOrders: data});
            }
        });
    }

    backToOrderList(){
        this.props.history.push("/orders");
    }
      
    render() {
        const button_print = couterpart.translate('button_print');
        const button_back = couterpart.translate('button_back');
        return(
            <div>
                <MenuComponent2/>
                <div className="printContainer">
                    <br/>
                    <div>
                        <button class="myButton" onClick={this.backToOrderList.bind(this)}>
                        <TiArrowBackOutline color={ICON_COLOR}/>&nbsp;{button_back}&nbsp;&nbsp;&nbsp;&nbsp;</button>&nbsp;&nbsp;
                        <ReactToPrint
                        trigger={() => <button class="myButton">
                        <FaPrint color={ICON_COLOR}/>&nbsp;
                        {button_print}&nbsp;&nbsp;&nbsp;&nbsp;</button>}
                        content={() => this.componentRef}
                        />
                        <hr/>                 
                        <OrderPrintContent workOrders={this.state.workOrders}
                            ref={el => (this.componentRef = el)}/> 
                    </div>                             
                </div>
            </div>
        );
    }
}

export default withRouter(OrderPrintResult);